<template>
<w-sliding-popup ref="slidingPopup" type="full" :title="selectTitle" @close="closePopup">
  <div slot="content">
    <div class="condition-box mr-b25">
      <span class="mr-r4">기간선택</span>
      <el-date-picker style="width: 225px;" :editable="false" type="daterange" v-model="dateRange" format="yyyy-MM-dd" :clearable="false" />
      <el-input size="small" style="width: 250px;" v-model="keyword" placeholder="검색 키워드를 입력해주십시오." suffix-icon="el-icon-search" @keyup.enter.native="searchChangeHist"/>
      <div class="fl-r mr-t2">
        <ul class="diff-legend-box">
          <li><span class="item added"></span>추가</li>
          <li><span class="item modified"></span>변경</li>
          <li><span class="item deleted"></span>삭제</li>
        </ul>
        <el-radio-group class="ordinary cmp-margin-left" v-model="changeDataFlag">
          <el-radio-button :label="false">변경내역만 보기</el-radio-button>
          <el-radio-button :label="true">전체 보기</el-radio-button>
        </el-radio-group>
      </div>
    </div>
    <div class="title-bar" type="flex">
      <div class="vertical-center-box" style="width:calc(50% - 15px);">
        <span class="title-h4 dot-title mr-r10">기준 컨피그</span>
        <el-select v-model="selectedHistDate" placeholder="변경 이력 선택" @change="changeDate">
          <el-option v-for="changeInfo in changeInfoList" :key="changeInfo.seqNumber" :label="convertCheckDatetime(changeInfo.checkDatetime)" :value="changeInfo.seqNumber"></el-option>
        </el-select>
        <span v-if="sameHist" style="margin-left: 10px;">동일한 이력입니다.</span>
      </div>
      <div class="mr-l15" style="width:50%;">
        <el-row type="flex" justify="space-between">
          <div class="vertical-center-box">
            <span class="title-h4 dot-title mr-r10">비교대상 컨피그</span>
            <el-select v-model="comparedHistDate" placeholder="변경 이력 선택" @change="changeDate">
              <el-option v-for="changeInfo in changeInfoList" :key="changeInfo.seqNumber" :label="convertCheckDatetime(changeInfo.checkDatetime)" :value="changeInfo.seqNumber"></el-option>
            </el-select>
          </div>

        </el-row>
      </div>
    </div>
    <el-row type="flex">
      <div style="width: 100%;" v-html="configurationOutput"></div>
    </el-row>
  </div>
</w-sliding-popup>
</template>

<script>
import { mapGetters } from 'vuex';
import eq from 'lodash/eq';
import isNil from 'lodash/isNil';
import clone from 'lodash/clone';
import forEach from 'lodash/forEach';
import { getDateToString } from '@/utils/date';
import vmsApi from '@/api/virtual/performance/common';
import databasInfoAPI from '@/api/config/database/database-info';

export default {
  name: 'WVmsChangeHistPopup',
  props: {
    selectHistParams: Object,
  },
  data() {
    return {
      keyword: '',
      selectTitle: '',
      showSearchTool: false,
      selectedHistDate: null,
      comparedHistDate: null,
      changeDataFlag: true,
      changeInfoList: [],
      dateRange: [],
      configurationOutput: '변경된 내역이 없습니다.',
      sameHist: false,
      params: {
        objId: null,
        typeKey: null,
      },
      dataList: null,
      configurationTotalData: null,
    };
  },
  computed: mapGetters(['selectedNode']),
  watch: {
    selectHistParams: {
      handler() {
        this.params.objId = this.selectHistParams.objId;
        this.params.typeKey = this.selectHistParams.typeKey;
        this.selectTitle = `${this.selectHistParams.typeName} (${getDateToString(this.selectHistParams.checkDatetime)})`;
        this.dateRange = clone(this.selectHistParams.dateRange);
      },
    },
    changeDataFlag: {
      handler() {
        this.setComparedData();
      },
    },
    dateRange: {
      handler() {
        this.loadData();
      },
    },
  },
  methods: {
    closePopup() {
      this.$refs.slidingPopup.visible = false;
    },
    open() {
      this.$refs.slidingPopup.visible = true;
    },
    loadData() {
      const me = this;
      const loadParams = {
        objId: me.params.objId,
        typeKey: me.params.typeKey,
        startDatetime: me.dateRange[0].getTime(),
        endDatetime: me.dateRange[1].getTime(),
      };
      // 타임라인에서 구성정보 비교 팝업 조회 시 Tree 노드 클릭 정보를 가져올 수 없어 selectHistParams에서 먼저 값을 찾는다.
      const target = this.selectHistParams.objDefineId ? this.selectHistParams.objDefineId : this.selectedNode.obj.objDefineId;
      // 트리에서 선택한 노드가 VMS인 경우에만 요청
      if (!isNil(loadParams) && (eq(target, 'VMS_OBJECT'))) {
        databasInfoAPI.getDbmsChangeHistDate(loadParams).then((response) => {
          if (response.data.success) {
            this.changeInfoList = response.data.data;
            this.setDataRange();
          }
        });
      }
    },
    convertCheckDatetime(value) {
      return getDateToString(value);
    },
    /**
     * [changeDate 날짜 변경시 현재/이전 config 비교 수행]
     */
    changeDate() {
      const loadParams = {
        objId: this.selectHistParams.objId,
        typeKey: this.selectHistParams.typeKey,
        histSeqList: this.selectedHistDate === this.comparedHistDate ? [this.selectedHistDate] : [this.selectedHistDate, this.comparedHistDate],
        objtypeId: this.selectHistParams.objDefineId ? this.selectHistParams.objDefineId : this.selectedNode.obj.objtypeId,
      };

      //   // combobox로 선택한 날짜가 같은 경우 sameHist true
      //   this.sameHist = this.selectedHistDate === this.comparedHistDate;

      vmsApi.compareVmsConfigHist(loadParams).then((response) => {
        if (response.data.success) {
          this.configurationTotalData = response.data.data;
          this.setComparedData();
        }
      });
    },
    /**
     * [setComparedData changeDate 결과에 대한 configOutput 설정]
     */
    setComparedData() {
      const configTotalData = clone(this.configurationTotalData);
      if (!isNil(configTotalData)) {
        if (this.changeDataFlag) {
          this.configurationOutput = isNil(configTotalData.compare) ? configTotalData.message : configTotalData.compare;
        } else if (!this.changeDataFlag) {
          this.configurationOutput = isNil(configTotalData.diff) ? configTotalData.message : configTotalData.diff;
        } else {
          this.configurationOutput = '변경된 내역이 없습니다.';
        }
      }
    },
    /**
     * [setDataRange 설정한 Datepicker의 변경시 수행]
     * @author yelim
     */
    setDataRange() {
      if (this.changeInfoList.length > 0) {
        const index = 0;
        this.comparedHistDate = this.changeInfoList[index].seqNumber; // Right : 최근 값
        if (isNil(this.changeInfoList[index + 1])) {
          this.selectedHistDate = this.changeInfoList[index].seqNumber;
        } else {
          this.selectedHistDate = this.changeInfoList[index + 1].seqNumber; // Left: 이전 값
        }
        this.changeDate();
      } else {
        this.changeInfoList = [];
        this.selectedHistDate = null;
        this.comparedHistDate = null;
        this.configurationOutput = '변경된 내역이 없습니다.';
        this.configurationTotalData = null;
      }
    },
    searchChangeHist() {
      const me = this;
      const htmlDataList = document.getElementsByTagName('pre');
      // 검색 키워드가 존재하는 경우.
      if (me.keyword !== '') {
        forEach(htmlDataList, (value) => {
          if (!isNil(value.innerText)) {
            const inner = value.innerText;
            const index = inner.search(me.keyword);
            if (index >= 0) {
              const replaceKeyword = inner.substr(index, this.keyword.length);
              const replaceString = `<b><span style="background-color: #A9E2F3">${replaceKeyword}</span></b>`;
              value.innerHTML = inner.replace(new RegExp(replaceKeyword, 'g'), replaceString);
            } else {
              value.hidden = true;
            }
          }
        });
        // 검색 키워드가 존재하지 않는 경우 필터링 되지않은 이력을 보여줘야 한다.
      } else {
        forEach(htmlDataList, (value) => {
          /*
          기존이력 중 hidden이 되어있지 않은 경우는 검색 결과가 highlight된 경우이고
          pre 태그 안의 html을 수정한 것이므로 해당 text를 다시 html에 덮어씌워 highlight를 없앤다.
          */
          if (value.hidden === false || value.innerHTML.search('<b>') > 0) {
            value.innerHTML = value.innerText;
          }
          value.hidden = false;
        });
        this.setComparedData();
      }
    },
  },
};
</script>

<style module>
.change-box-left {
  width: calc(50% - 4px);
  margin-right: 4px;
}

.change-box-right {
  width: calc(50% - 4px);
  margin-left: 4px;
}
</style>



// WEBPACK FOOTER //
// src/views/config/node/components/VmsChangeHistPopup.vue